import React, { useState } from 'react';
import { Link as ButtonLink } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import truncate from 'html-truncate';

import { HtmlToMUIMapper, stripHtml } from '../../Utils';

function ReadMore({ content, maxLength = 1000, expand = true }: any) {
  const [open, setOpen] = useState(false);
  const stripedContent = stripHtml(content);
  const truncatedContent = truncate(content, maxLength, { ellipsis: '…' });
  const displayReadMore = stripedContent.length > maxLength;

  if (expand || open || !displayReadMore) {
    return <HtmlToMUIMapper content={content} />;
  }

  return (
    <>
      <HtmlToMUIMapper content={truncatedContent} />

      {displayReadMore && (
        <ButtonLink
          component="button"
          onClick={() => setOpen(!open)}
          variant="body1"
          underline="hover"
          sx={{ ml: 1 }}
        >
          <strong>
            <FormattedMessage id="BUTTONS.READ_MORE" />
          </strong>
        </ButtonLink>
      )}
    </>
  );
}

ReadMore.propTypes = {
  content: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
  expand: PropTypes.bool,
};

export default ReadMore;
